import type { UseMutationOptions } from "react-query";
import { useMutation } from "react-query";
import type { CreateConnectionParams } from "@/react/api";
import { connectionsApi } from "@/react/api";

export const useCreateConnection = (
  options?: UseMutationOptions<any, Error, CreateConnectionParams>,
) => useMutation(connectionsApi.createConnection, options);
